import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import sicrediColor from 'assets/styles/default.scss';

export default makeStyles(
  (theme: Theme) =>
    createStyles({
      root: {
        padding: theme.spacing(2),
        overflowX: 'hidden',
      },
      upperTitle: {
        fontFamily: '"Exo 2", sans-serif',
        fontSize: 20,
        fontWeight: 600,
        lineHeight: '24px',
        textAlign: 'justify',
        margin: theme.spacing(1.5, 0),
        color: '#595959',
        //styleName: Title 4 Focus;
      },
      title: {
        fontSize: 18,
        fontWeight: 700,
        lineHeight: '24px',
        textAlign: 'justify',
        margin: theme.spacing(1.5, 0),
      },
      subtitle: {
        fontSize: 16,
        fontWeight: 400,
        lineHeight: '24px',
        textAlign: 'justify',
        color: '#323C32',
        margin: theme.spacing(1.5, 0),
      },
      item: {
        diplay: 'flex',
        justifyContent: 'center',
        margin: theme.spacing(0.5, 0),
        '&:first-of-type': {
          marginTop: theme.spacing(2),
        },
        '&:last-of-type': {
          marginBottom: theme.spacing(2),
        },
      },
      itemText: {
        fontFamily: '"Nunito", sans-serif',
        fontSize: 16,
        fontWeight: 300,
        lineHeight: '24px',
        textAlign: 'left',
      },
      itemPerc: {
        fontFamily: '"Nunito", sans-serif',
        fontSize: 16,
        fontWeight: 700,
        lineHeight: '24px',
        textAlign: 'right',
        color: sicrediColor.primarySicredi,
      },
      itemProgress: {
        marginTop: theme.spacing(1),
      },
      advice: {
        fontFamily: '"Nunito", sans-serif',
        fontSize: 15,
        fontWeight: 400,
        lineHeight: '24px',
        textAlign: 'justify',
      },
      selectIcon: {
        color: sicrediColor.primarySicredi,
        fontSize: 16,
        marginLeft: -24,
        '.Mui-disabled &': {
          color: sicrediColor.secondarySicrediLight,
        },
      },
      votosContainer: {
        padding: '13px 0',
      },
      votosLabel: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
      },
      itemTextLabel: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        marginBottom: theme.spacing(2),
        '& span': {
          flex: 'auto',
          fontSize: 15,
          fontWeight: 700,
          lineHeight: '24px',
        },
        '& span:not(:first-of-type)': {
          marginLeft: theme.spacing(2),
        },
      },
      itemTextLower: {
        fontSize: '16px',
      },
      consolidadoContainer: {
        margin: '16px 0',
      },
      paddingTop: {
        paddingTop: 20
      }
    }),
  { name: 'ResultadosModal' }
);
